import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import IMG1 from "../../images/industries/fintech/Rich-UI-UX.webp";
import IMG2 from "../../images/industries/fintech/Biometric-Security.webp";
import IMG3 from "../../images/industries/fintech/Budgeting.webp";
import IMG4 from "../../images/industries/fintech/Gamification.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Demandfeatures(props) {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const getActiveClass = (index, className) =>
    toggleState === index ? className : "";
  return (
    <section className="tekrevol_gray_bg p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Fintech Software">
              <h2>Our Innovative Solutions for Secure Fintech Development</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              We keep up with the latest breakthroughs like Blockchain, IoT, and
              AI to create fintech software solutions that are effective,
              user-friendly, and secure.
            </p>
            <p>
              We as a fintech development company ensure that all fintech
              projects from small mobile apps to large-scale networks for
              multi-party transaction processing are implemented quickly and
              securely.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                0,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(0)}
            >
              <LazyLoadImage
                src={IMG1}
                effect="blur"
                alt="fintech software development company"
                className="img-fluid"
              />
              <h6>Rich UI/UX</h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                1,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(1)}
            >
              <LazyLoadImage
                src={IMG2}
                effect="blur"
                alt="fintech software development company"
                className="img-fluid"
              />
              <h6>Biometric Security</h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                2,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(2)}
            >
              <LazyLoadImage
                src={IMG3}
                effect="blur"
                alt="fintech software development services"
                className="img-fluid"
              />
              <h6>Budgeting</h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                3,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(3)}
            >
              <LazyLoadImage
                src={IMG4}
                effect="blur"
                alt="fintech software development services"
                className="img-fluid"
              />
              <h6>Gamification</h6>
            </div>
          </Col>

          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 0
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              We ensure every step, from gathering requirements for the project
              to development and on-premise deployment, is aligned to delivering
              exceptional user experience. Our expertise lies in developing
              UX-focused Fintech products that make the end user feel valued.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 1
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              As a Fintech solutions software development company, we strongly
              emphasize building secured and breach-proof Fintech solutions. We
              believe that developing fail-proof Fintech software with
              impregnable security layers is one thing that must be considered,
              no matter what. Thus, we hire the finest Fintech development teams
              to ensure the end users feel safe and secure using our products.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 2
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              For a comprehensive Fintech software solution, budgeting and
              wealth management are the must-have features to include. Whether
              you want to integrate budgeting into your Fintech software, create
              a standalone budgeting app, or start your journey as an
              entrepreneur, we can help.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 3
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              Gamification is a strategic approach to optimizing software
              solutions by creating game-like environments to enhance user
              experience. Our Fintech software company can help you gamify your
              existing Fintech software solution or create a new one from
              scratch with game-like features to increase engagement.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Demandfeatures;
